import {forwardRef, MouseEventHandler} from 'react'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {InteractFn, SpacialFn, styled, VisualFn} from '@yosmanyga/web-style'
import {ContainerProps} from '@yosmanyga/primitive-ui-spec'

const Container = forwardRef<HTMLDivElement, ContainerProps<
  MouseEventHandler<HTMLDivElement>
> & UnnormalizedStyleProps>(({
  onClick,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
  tooltip,
  className, testId,
  children
}, ref) => {
  return <div
    ref={ref}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onMouseDown={onMouseDown}
    data-tip={tooltip ? tooltip : undefined}
    className={className}
    data-testid={testId}
  >
    {children}
  </div>
})

const StyledContainer = styled(Container)`
  ${({flow}) => SpacialFn.compileFlow(SpacialFn.normalizeFlow(flow))}
  ${({flex}) => SpacialFn.compileFlex(SpacialFn.normalizeFlex(flex))}
  ${({grid}) => SpacialFn.compileGrid(grid)}
  ${({gap}) => SpacialFn.compileGap(gap)}
  ${({box}) => SpacialFn.compileBox(box)}
  ${({table}) => SpacialFn.compileTable(table)}
  ${({align}) => SpacialFn.compileAlign(align)}
  ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
  ${({height}) => SpacialFn.compileHeight(SpacialFn.normalizeHeight(height))}
  ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
  ${({padding}) => SpacialFn.compilePadding(SpacialFn.normalizePadding(padding))}
  ${({z}) => SpacialFn.compileZ(z)}
  ${({position}) => SpacialFn.compilePosition(SpacialFn.normalizePosition(position))}
  ${({animation}) => SpacialFn.compileAnimation(animation)}
  ${({color}) => VisualFn.compileColor(color)}
  ${({background}) => VisualFn.compileBackground(VisualFn.normalizeBackground(background))}
  ${({opacity}) => VisualFn.compileOpacity(opacity)}
  ${({border}) => VisualFn.compileBorder(VisualFn.normalizeBorder(border))}
  ${({wrap}) => VisualFn.compileWrap(wrap)}
  ${({visibility}) => VisualFn.compileVisibility(visibility)}
  ${({scroll}) => VisualFn.compileScroll(scroll)}
  ${({overflow}) => VisualFn.compileOverflow(overflow)}
  ${({transform}) => VisualFn.compileTransform(transform)}
  ${({cursor}) => InteractFn.compileCursor(cursor)}
  &:hover {
    ${({pseudo}) => VisualFn.compileBackground(VisualFn.normalizeBackground(pseudo?.hover?.background))}
    ${({pseudo}) => VisualFn.compileTransition(pseudo?.hover?.transition)}
    ${({pseudo}) => VisualFn.compileFilter(pseudo?.hover?.filter)}
  }

  &:empty {
    ${({pseudo}) => SpacialFn.compileDisplay(pseudo?.empty?.display)}
  }
`

export default StyledContainer
